module.exports = __webpack_public_path__ + "img/argomenti_todolist.edbabd44.png";